import Axios from "../../../networking/intraceptor";
import { common_message_send } from "../../../networking/urlEndPoints";

// Text Message Actions
export const SEND_TEXT_REQUEST = 'SEND_TEXT_REQUEST';
export const SEND_TEXT_SUCCESS = 'SEND_TEXT_SUCCESS';
export const SEND_TEXT_FAILURE = 'SEND_TEXT_FAILURE';

// Action Creators
const sendTextRequest = () => ({ type: SEND_TEXT_REQUEST });
const sendTextSuccess = (data) => ({ type: SEND_TEXT_SUCCESS, payload: data });
const sendTextFailure = (error) => ({ type: SEND_TEXT_FAILURE, payload: error });

// Add a new flag to track ongoing requests
let isMessageSending = false;

export const sendPatientText = (requestData) => {
    return async (dispatch) => {
        if (isMessageSending) {
            return Promise.reject(new Error('A message is already being sent'));
        }
        
        isMessageSending = true;
        dispatch(sendTextRequest());
        
        try {
            // If updating phone number, make sure to validate it server-side
            if (requestData.update_phone) {
                // You might want to update the patient's phone number in your database
                // This would require a separate API endpoint or parameter
                const response = await Axios.post(common_message_send, {
                    ...requestData,
                    update_patient_phone: true // Add flag for backend to update phone
                });
                
                if (response?.status === 200) {
                    dispatch(sendTextSuccess(response.data));
                    isMessageSending = false;
                    return response;
                }
            } else {
                // Regular message send without phone update
                const response = await Axios.post(common_message_send, requestData);
                
                if (response?.status === 200) {
                    dispatch(sendTextSuccess(response.data));
                    isMessageSending = false;
                    return response;
                }
            }
            
            throw new Error('Failed to send text message');
        } catch (error) {
            dispatch(sendTextFailure(error));
            isMessageSending = false;
            throw error;
        }
    };
}; 